import { Link } from 'react-router-dom';
import './BotaoContatoOutline.css';

function BotaoContatoOutline({ texto, rota }) {
  return (
    <Link 
      to={rota} 
      className="btn btn-outline-light me-3 mb-2"
    >
      {texto}
    </Link>
  );
}

export default BotaoContatoOutline;
